"use client";

import { Switch as SwitchPrimitive } from "@base-ui/react/switch";

import { cn } from "@/shared/utils";

function Switch({ className, ...props }: SwitchPrimitive.Root.Props) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        "group/switch relative inline-flex h-6 w-10 shrink-0 cursor-pointer items-center rounded-full p-0.5",
        "bg-[#2A2A2A] transition-colors outline-none data-checked:bg-white",
        "focus-visible:ring-2 focus-visible:ring-white/40 focus-visible:ring-offset-2 focus-visible:ring-offset-[#141414]",
        "data-disabled:cursor-not-allowed",
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          "pointer-events-none block size-5 rounded-full transition-transform",
          "bg-white data-checked:bg-[#0A0A0A]/50",
          "shadow-[0px_3px_1px_0px_#0000000F,0px_3px_8px_0px_#00000026,0px_0px_0px_1px_#0000000A]",
          "data-unchecked:translate-x-0 data-checked:translate-x-4"
        )}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
